import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';

export const paymentsAdminRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'payments-admin' },
    loadComponent: () => import('./payments-admin/payments-admin.page').then((m) => m.PaymentsAdminPage),
    path: '',
  },
];
